import React, { Component } from 'react';
import { appService } from '../../_services';
let options1 = '', options2 = '', Itemid = ''

var itemList = [], publicationList=[],PAList=[];

export class List extends React.Component {
    constructor() {
        super();
        this.state = { showgeneral: false };
        this.state = {
            list: [],
            SubList: [],
            ShowSublist: []
        }
        this.HandleClick = this.HandleClick.bind(this);
        this.CheckboxClick = this.CheckboxClick.bind(this);
        this.SubitemChangeClick = this.SubitemChangeClick.bind(this);
        this.ExpandAll = this.ExpandAll.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.ClearList = this.ClearList.bind(this);
    }

    componentDidMount() {
        var self = this;

        appService.getAll('Product/GetPublicationsByTopic').then(function (data) {
           

            data.map((item, index) => (
                options1 = self.state.list,
                options1.push(item),

                options2 = self.state.SubList,
                options2.push(item.products),

                self.setState({
                    list: options1,
                }),

                self.setState({
                    SubList: options2
                })
            ))
           
            })
        //appService.getAll('Product/GetAllProductDetails').then(function (data) {
        //    {
        //        console.log(data);
        //        data.map((item, index) => (
        //            options1 = self.state.list,
        //            options1.push(item.productViewModel),

        //            options2 = self.state.SubList,
        //            options2.push(item.productDetailsVM),

        //            self.setState({
        //                list: options1,
        //            }),

        //            self.setState({
        //                SubList: options2
        //            })
        //        ))
        //    }
        //});

    }

    ClearList = (e) => {
        let list = this.state.list;
        list.forEach(item => {
            item.isChecked = false;
        });

        this.setState({
            list: list
        })

        let SubList = this.state.SubList;
        SubList.forEach(Pdtldtl => {
            Pdtldtl.forEach(Subitem => {
                Subitem.isChecked = false
            })
        });

        this.setState({
            SubList: SubList
        })
    }

    selectAll() {
        let list = this.state.list;
        list.forEach(item => {
            item.isChecked = true;
        });

        this.setState({
            list: list
        })

        let SubList = this.state.SubList;
        SubList.forEach(Pdtldtl => {
            Pdtldtl.forEach(Subitem => {
                Subitem.isChecked = true
            })
        });

        this.setState({
            SubList: SubList
        })
    }

    HandleClick(e) {
        if (this.state.ShowSublist.some(item => e.target.id === item) &&
            e.target.className === "fa fa-minus") {

            let index = this.state.ShowSublist.indexOf(e.target.id);
            if (index > -1) {
                this.state.ShowSublist.splice(index, 1);
                this.setState({ ShowSublist: this.state.ShowSublist });
            };
            e.target.className = "fa fa-plus";
        }
        else {
            let options = this.state.ShowSublist;
            options.push(e.target.id);

            this.setState({
                ShowSublist: options
            })
            e.target.className = "fa fa-minus";
        }

    }

    updateCount = (e) => {
        this.props.SalesCallback(publicationList);
       
    }

    GetPA = (e) => {
        this.props.SalesCallbackPA([...new Set(PAList.map(item => item))]);
    }

    ExpandAll() {
        this.setState({ showgeneral: !this.state.showgeneral });
        this.setState({ ShowSublist: [] });

        var elems = document.querySelectorAll(".fa-plus");
        var Elem = document.querySelectorAll(".fa-minus");

        if (elems.length > 0) {
            [].forEach.call(elems, function (el) {
                el.className = el.className.replace(/\bfa-plus\b/, "fa-minus");
            });
        }
        else {
            [].forEach.call(Elem, function (el) {
                el.className = el.className.replace(/\bfa-minus\b/, "fa-plus");
            });

        }
    }

    CheckboxClick(evt) {
        let list = this.state.list;
        list.forEach(item => {
            if (item.id == evt.target.value) {
                Itemid = item.id;
                item.isChecked = evt.target.checked;
                //Adding/Removing  parent when clicked
                if (evt.target.checked) {                    
                    itemList.push(item.topic);
                    PAList.push(item.topic);
                }
                else {
                    var index = itemList.indexOf(item.topic);
                    if (index !== -1) {
                        itemList.splice(index, 1);
                    }

                    var nindex = PAList.indexOf(item.topic);
                    if (nindex !== -1) {
                        PAList.splice(nindex, 1);
                    }
                }
            }
        });
        this.setState({
            list: list
        })

        let Sublist = this.state.SubList;

        Sublist.forEach(Pdtldtl => {
            Pdtldtl.forEach(Subitem => {
                if (Subitem.topicId == Itemid) {
                    Subitem.isChecked = evt.target.checked
                    //Adding/Removing  children when clicked
                    if (evt.target.checked) {
                        itemList.push(Subitem.title);
                        publicationList.push(Subitem.title);
                    }
                    else {
                        var index = itemList.indexOf(Subitem.title);
                        var newindex = publicationList.indexOf(Subitem.title);
                        if (index !== -1) {
                            itemList.splice(index, 1);
                        }
                        if (newindex !== -1) {
                            publicationList.splice(newindex, 1);
                        }
                    }
                }
            }
            )
        });
        this.setState({
            SubList: Sublist
        })
        this.updateCount();
        this.GetPA();
    }

    SubitemChangeClick(evt) {
        let Sublist = this.state.SubList;
        let list = this.state.list;
        var data = evt.target.id.split('_');
        var Setfalse = "false" + "_" + data[0];
        var SetTrue = "true" + "_" + data[0];
        Sublist.forEach(Pdtldtl => {
            Pdtldtl.forEach(Subitem => {
                
                if (Subitem.id == data[1] && Subitem.topicId==data[0]) {
                    Subitem.isChecked = evt.target.checked;
                    //Add/Remove individual child or Sub item from select list based on check or uncheck
                    if (evt.target.checked) {
                        itemList.push(Subitem.title);
                        publicationList.push(Subitem.title);
                        list.filter(Listdata => Listdata.id == Subitem.topicId).forEach(ListDetail => {
                            PAList.push(ListDetail.topic)
                        });
                    }
                    else {
                        var index = itemList.indexOf(Subitem.title);
                        if (index !== -1) {
                            itemList.splice(index, 1);
                        }
                        var newindex = publicationList.indexOf(Subitem.title);
                        if (newindex !== -1) {
                            publicationList.splice(newindex, 1);
                        }
                        //list.filter(Listdata => Listdata.id == Subitem.topicId).forEach(ListDetail => {
                        //    var newpaindex = PAList.indexOf(ListDetail.topic);
                        //    if (newpaindex !== -1) {
                        //        PAList.splice(newpaindex, 1);
                        //    }
                        //})
                    }
                }
                if (evt.target.checked == false) {
                    this.state.list.forEach(item => {
                        if (Subitem.id == data[1] && Subitem.topicId == item.id && item.id == data[0]) {
                            item.isChecked = evt.target.checked;
                            //Remove parent when one child checked
                            var index = itemList.indexOf(item.topic);
                            if (index !== -1) {
                                itemList.splice(index, 1);
                            }

                            //var newindex = PAList.indexOf(item.topic);
                            //if (newindex !== -1) {
                            //    PAList.splice(newindex, 1);
                            //}
                        }
                    });
                }
            })

            if (Pdtldtl.filter(SubListdata => SubListdata.topicId == data[0] && SubListdata.isChecked == false).length > 0) {
                Pdtldtl.forEach(Subitem => {
                    if (Subitem.isChecked == false) {
                        Setfalse = "true" + "_" + Subitem.topicId;
                    }
                })
            }

            if (Pdtldtl.filter(SubListdata => SubListdata.topicId == data[0] && SubListdata.isChecked == true).length > 0) {

                list.filter(Listdata => Listdata.id == data[0]).forEach(ListDetail => {
                    PAList.push(ListDetail.topic)
                });
            }

        })

        if (SetTrue == true + "_" + data[0]) {

            list.filter(Listdata => Listdata.id == data[0]).forEach(ListDetail => {

                    var newindex = PAList.indexOf(ListDetail.topic);
                    if (newindex !== -1) {
                        PAList.splice(newindex, 1);
                    }

            })
        }

        if (Setfalse == false + "_" + data[0]) {
            this.state.list.forEach(item => {
                if (data[0] == item.id) {
                    item.isChecked = evt.target.checked;
                    //Adding parent when all child are checked
                    if (evt.target.checked) {
                        itemList.push(item.topic);
                        //publicationList.push(item.topic);
                    }
                }
            })
        }

        this.setState({
            SubList: Sublist
        })
        this.updateCount();
        this.GetPA();

    }

    renderList = () => {
        return this.state.list.map(item =>
            <li key={item.id} style={{ listStyle: 'none' }}>
                <div className="form-group" key={item.id}>
                    <div className="square">
                        <input type="checkbox" id={item.id}
                            name={item.topic} value={item.id} checked={item.isChecked} onChange={this.CheckboxClick} />

                        <label htmlFor={item.id}></label>
                        <i style={{ fontSize: '18px', color: '#007AC3', paddingLeft: '5%', paddingRight: '2%' }}
                            className="fa fa-plus" id={item.id} onClick={this.HandleClick}></i>
                        <span className="LinkClass"> {item.topic}</span>
                    </div>

                    {(() => {
                        if (this.state.ShowSublist.length > 0) {

                            return (

                                this.state.ShowSublist.map(Subitem =>

                                    <div key={Subitem}>

                                        {(() => {

                                            if (Subitem == item.id) {
                                                return (
                                                    this.state.SubList.map(Pdtldtl =>
                                                        
                                                        Pdtldtl.map(SubListItem =>
                                                            <div key={SubListItem.id}>

                                                                {(() => {

                                                                    if (SubListItem.topicId == item.id && SubListItem.title !== '')

                                                                        return (
                                                                            <div style={{ paddingLeft: '25px', paddingTop: '1%' }} key={SubListItem.title}>

                                                                                <div className="square">
                                                                                    <input checked={SubListItem.isChecked} type="checkbox" id={item.id + "_" + SubListItem.id}
                                                                                        name={item.id + "_" + SubListItem.id} value={item.id + "_" + SubListItem.id}
                                                                                        onChange={this.SubitemChangeClick} />
                                                                                    <label htmlFor={item.id + "_" + SubListItem.id}></label>
                                                                                    <span style={{ paddingLeft: '5%', fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: SubListItem.title }}></span>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                }
                                                                )()}
                                                            </div>
                                                        ))
                                                )
                                            }
                                        }
                                        )()}

                                    </div>
                                )

                            )

                        }

                        else {
                            return (
                                this.state.showgeneral ?
                                    this.state.SubList.map(Pdtldtl =>
                                        Pdtldtl.map(Subitem =>
                                            <div key={Subitem.id}>
                                                {(() => {
                                                    if (Subitem.topicId == item.id && Subitem.title !== '')
                                                        return (
                                                            <div style={{ paddingLeft: '25px', paddingTop: '1%' }} key={Subitem.title}>

                                                                <div className="square">
                                                                    <input checked={item.isChecked} type="checkbox" id={item.id + "_" + Subitem.id}
                                                                        name={item.id + "_" + Subitem.id} value={item.id + "_" + Subitem.id}
                                                                        onChange={this.SubitemChangeClick} />
                                                                    <label htmlFor={item.id + "_" + Subitem.id}></label>
                                                                    <span style={{ paddingLeft: '5%', fontSize: '12px' }}>{Subitem.title}</span>
                                                                </div>
                                                            </div>
                                                        )

                                                    else {
                                                        return (
                                                            <div ></div>
                                                        )
                                                    }
                                                }
                                                )()}
                                            </div>
                                        ))

                                    : null
                            )
                        }

                    }
                    )()}
                </div>
            </li>
        )
    }



    render() {
        return (
            <form>
                <h6 className="my-3" style={{ display: 'inline-block' }}>Practice area/Publication</h6>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ fontSize: '12px' }} className="LinkClass HoverUnderline" onClick={this.selectAll}>(Select all)</span>

                {this.renderList()}
            </form>

        );
    }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/Home/List.jsx